// extracted by mini-css-extract-plugin
export default {"idle-notification-container":"kxVnhKUX4KxyI9-hNTDBZg=="};